<template>
  <div>
    <div v-if="loading" class="pt-5 text-xs-center">
      <v-progress-circular indeterminate color="primary" size="60"></v-progress-circular>
    </div>
    <div v-else>
      <template>
        <div
          v-if="!notiBeforToggle"
          class="btn-floating btn-outline-red text-xs-center"
          style="float: right"
          @click="showEditnotiBeforToggle"
        >
          <em class="fa fa-pencil-alt middle" />
        </div>
        <div class="primary--text" style="font-weight: bold">
          การแจ้งเตือนไปยังลูกค้าก่อนติดตั้ง
        </div>
        <p style="color: #000000" class="mt-3">จำนวนวันก่อนติดตั้ง</p>
        <p v-if="!notiBeforToggle" class="primary-color">
          {{ notify_before_install_date }} <span>วัน</span>
        </p>
        <p v-else class="form-control pa-1" :class="{ 'has-error': errors.has('before') }">
          <input
            v-model="input_before.notify_before_install_date"
            style="width: 85px"
            small
            :data-vv-as="$t('before')"
            name="before"
            class="form-control"
            type="number"
          />
          <span v-if="errors.has('before')" class="text-error">{{ errors.first('before') }}</span>
          <span class="primary-color">วัน</span>
        </p>

        <p style="color: #000000">ข้อความ</p>
        <p v-if="!notiBeforToggle">
          {{ notify_before_install_message }}
        </p>
        <div v-else class="form-control px-1" :class="{ 'has-error': errors.has('details') }">
          <textarea
            id="details"
            v-model="input_before.notify_before_install_message"
            name="details"
            style="width: 100%; min-height: 100px"
            :data-vv-as="$t('details')"
            class="form-control"
          ></textarea>
          <p v-if="errors.has('details')" class="text-error">{{ errors.first('details') }}</p>
        </div>

        <div v-if="notiBeforToggle" class="text-xs-left">
          <v-btn :loading="saveloading" depressed color="primary" @click="saveBefore">{{
            $t('Save')
          }}</v-btn>
          <v-btn color="grey" outline @click="notiBeforToggle = false">{{ $t('cancel') }}</v-btn>
        </div>
      </template>

      <template>
        <div class="mt-5">
          <div
            v-if="!notiAfterToggle"
            class="btn-floating btn-outline-red text-xs-center"
            style="float: right"
            @click="showEditnotiAfterToggle"
          >
            <em class="fa fa-pencil-alt middle" />
          </div>
          <div class="primary--text" style="font-weight: bold">
            การแจ้งเตือนไปยังลูกค้าหลังติดตั้ง
          </div>
          <p style="color: #000000" class="mt-3">จำนวนวันหลังติดตั้ง</p>
          <p v-if="!notiAfterToggle" class="primary-color">
            {{ notify_after_install_date }} <span>วัน</span>
          </p>
          <p v-else class="form-control pa-1" :class="{ 'has-error': errors.has('after') }">
            <input
              v-model="input_after.notify_after_install_date"
              style="width: 85px"
              small
              :data-vv-as="$t('after')"
              name="after"
              class="form-control"
              type="number"
            />
            <span v-if="errors.has('after')" class="text-error">{{ errors.first('after') }}</span>
            <span class="primary-color">วัน</span>
          </p>

          <p style="color: #000000">ข้อความ</p>
          <p v-if="!notiAfterToggle">{{ notify_after_install_message }}</p>
          <div v-else class="form-control px-1" :class="{ 'has-error': errors.has('details') }">
            <textarea
              id="details"
              v-model="input_after.notify_after_install_message"
              name="details"
              style="width: 100%; min-height: 100px"
              :data-vv-as="$t('details')"
              class="form-control"
            ></textarea>
            <p v-if="errors.has('details')" class="text-error">{{ errors.first('details') }}</p>
          </div>

          <div v-if="notiAfterToggle" class="text-xs-left">
            <v-btn :loading="saveloading" depressed color="primary" @click="saveAfter">{{
              $t('Save')
            }}</v-btn>
            <v-btn color="grey" outline @click="notiAfterToggle = false">{{ $t('cancel') }}</v-btn>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      saveloading: false,
      input_before: {
        notify_before_install_date: '',
        notify_before_install_message: ''
      },
      input_after: {
        notify_after_install_date: '',
        notify_after_install_message: ''
      },
      notiBeforToggle: false,
      notiAfterToggle: false,
      loading: true,
      notify_before_install_date: '', // จำนวนวันแจ้งเตือนก่อนติดตั้ง
      notify_before_install_message: '', // ข้อความแจ้งเตือนก่อนติดตั้ง
      notify_after_install_date: '', // จำนวนวันแจ้งเตือนหลังติดตั้ง
      notify_after_install_message: '' // ข้อความแจ้งเตือนหลังติดตั้ง
    }
  },
  computed: {
    ...mapGetters(['selectedBot'])
  },
  mounted() {
    this.getData()
  },
  methods: {
    async saveBefore() {
      this.saveloading = true
      var allsave = [
        this.SaveNotifyBeforeInstallDate(),
        this.SaveupdateNotifyBeforeInstallMessage()
      ]
      await Promise.all(allsave)
      this.notify_before_install_date = this.input_before.notify_before_install_date
      this.notify_before_install_message = this.input_before.notify_before_install_message
      this.notiBeforToggle = false
      this.saveloading = false
    },
    async saveAfter() {
      this.saveloading = true
      var allsave = [this.SaveNotifyAfterInstallDate(), this.SaveupdateNotifyAfterInstallMessage()]
      await Promise.all(allsave)
      this.notify_after_install_date = this.input_after.notify_after_install_date
      this.notify_after_install_message = this.input_after.notify_after_install_message
      this.notiAfterToggle = false
      this.saveloading = false
    },
    showEditnotiBeforToggle() {
      this.input_before.notify_before_install_date = this.notify_before_install_date
      this.input_before.notify_before_install_message = this.notify_before_install_message
      this.notiBeforToggle = true
    },
    showEditnotiAfterToggle() {
      this.input_after.notify_after_install_date = this.notify_after_install_date
      this.input_after.notify_after_install_message = this.notify_after_install_message
      this.notiAfterToggle = true
    },

    SaveNotifyBeforeInstallDate() {
      return new Promise((resolve) => {
        api.kingkitchenupdateNotifyBeforeInstallDate(
          {
            pageid: this.selectedBot.pageid,
            notify_before_install_date: this.input_before.notify_before_install_date
          },
          (err, response) => {
            resolve()
          }
        )
      })
    },
    SaveupdateNotifyBeforeInstallMessage() {
      return new Promise((resolve) => {
        api.kingkitchenupdateNotifyBeforeInstallMessage(
          {
            pageid: this.selectedBot.pageid,
            notify_before_install_message: this.input_before.notify_before_install_message
          },
          (err, response) => {
            resolve()
          }
        )
      })
    },
    SaveNotifyAfterInstallDate() {
      return new Promise((resolve) => {
        api.kingkitchenupdateNotifyAfterInstallDate(
          {
            pageid: this.selectedBot.pageid,
            notify_after_install_date: this.input_after.notify_after_install_date
          },
          (err, response) => {
            resolve()
          }
        )
      })
    },
    SaveupdateNotifyAfterInstallMessage() {
      return new Promise((resolve) => {
        api.kingkitchenupdateNotifyAfterInstallMessage(
          {
            pageid: this.selectedBot.pageid,
            notify_after_install_message: this.input_after.notify_after_install_message
          },
          (err, response) => {
            resolve()
          }
        )
      })
    },
    getData() {
      api.kingkitchengetsetting({ pageid: this.selectedBot.pageid }, (err, response) => {
        this.notify_before_install_date = response.data[0].notify_before_install_date
        this.notify_before_install_message = response.data[0].notify_before_install_message
        this.notify_after_install_date = response.data[0].notify_after_install_date
        this.notify_after_install_message = response.data[0].notify_after_install_message

        this.loading = false
      })
    }
  }
}
</script>

<style lang="sass" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/kingKitchen/adminMenu/Setting.vue